export default __webpack_public_path__ + "static/media/AO-1.7d15cca0.jpg";